require('./emitter.spec')
require('./ruby-specs/all')
require('./simple.spec')
require('./object.spec')
require('./hypermedia.spec')
